import React, { useState } from "react";
import ExpertCard from "./ExpertCard";
import NavigationArrows from "./NavigationArrows";
import styles from "./styles.module.css";

const MobileExprerts = ({ experts }) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  const setNextTeamCard = () => {
    if (currentCardIndex < experts.length - 1) {
      setCurrentCardIndex(currentCardIndex + 1);
    }
  };

  const setPreviousTeamCard = () => {
    if (currentCardIndex > 0) {
      setCurrentCardIndex(currentCardIndex - 1);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.containerForTitle}>
        <div className={styles.flex}>
          <div className={styles.title}>Эксперты</div>
        </div>
        <div className={styles.text}>
          Главные действующие лица криптоиндустрии, пережившие все булраны и
          зимовки.
        </div>
      </div>
      <div className={styles.mobileWrap}>
        <ExpertCard expert={experts[currentCardIndex]} />
        <NavigationArrows
          isPrev={currentCardIndex !== 0}
          isNext={currentCardIndex !== experts.length - 1}
          prev={setPreviousTeamCard}
          next={setNextTeamCard}
        />
      </div>
    </div>
  );
};

export default MobileExprerts;
